if (!customElements.get('coco-shuffle')) {
	class CocoShuffle extends HTMLElement {
		constructor() {
			super();
			this.selectedProduct = null;
			this.selectedSize = null;
		}

		connectedCallback() {
			this.copySection = document.querySelector('.shopify-section.section_copy');
			this.stickyCopy = this.querySelector('[data-copy-section]');

			if (this.copySection && this.stickyCopy) {
				this.stickyCopy.innerHTML = this.copySection.innerHTML;
				this.stickyCopy.classList.add('hidden', 'md:block', ...this.copySection.classList);
				this.copySection.classList.add('md:hidden');
			}

			this.products = JSON.parse(this.dataset.productsJson
				.replaceAll('%27', '&apos;')
				.replaceAll('%22', '&quot;')
			);

			this.baseProduct = this.products.find(product => product.tags.find(x => x === 'base_product'));
			const initialSelectId = this.querySelector('[data-coco-selector][data-value]')?.dataset.value;
			this.selectedProduct = this.products.find(({ id }) => id === initialSelectId);
			if (!this.selectedProduct) this.selectedProduct = this.products.find(({ handle }) => window.location.pathname.includes(handle));
			if (this.selectedProduct?.id === this.baseProduct?.id || !this.selectedProduct) {
				this.selectedProduct = this.products.find(x => x.available && !x.tags.some(tag => ['base_product', 'newsite-hidden'].some((value) => value === tag)));
			}
			this.currentVariant = this.selectedProduct.variants
				.find(({ default_selected }) => default_selected) || this.selectedProduct.variants[0];
			this.addDelegatedClickListeners();
			this.createCustomEvents();
			window.addEventListener('selling-plan-selector:plan-selected', this.populateSelectedProductPrice.bind(this));
			document.addEventListener('DOMContentLoaded', () => {
				// any elements that might not exist yet when the ACE gets added to the DOM
				this.imagesWrapper = [...this.querySelectorAll('[data-product-images]')];
				this.displayPrices = [...this.querySelectorAll('[data-display-price]')];
				this.displayOptions = this.querySelector('[data-display-options]');
				this.displayTitles = [...this.querySelectorAll('[data-display-title]')];
				this.mainSelect = this.querySelector('[data-main-select]');
				this.ageCheck();
				this.populateSelectedProductPrice();
			});
		}

		addDelegatedClickListeners() {
			this.addEventListener('click', (e) => {
				const clickedElement = e.target.closest('[data-action]');
				if (!clickedElement) return;

				const {
					action,
					productId,
					option
				} = clickedElement.dataset;

				switch (action) {
					case 'product-select':
						if (productId === this.selectedProduct?.id) return;

						this.selectedProduct = this.products.find(({ id }) => id === productId);
						this.currentVariant = this.selectedProduct.variants
							.find(({ default_selected }) => default_selected) || this.selectedProduct.variants[0];
						this.populateSelectedProductImages();
						this.populateSelectedProductPrice();
						this.populateSelectedProductOptions();
						this.populateSizeDisplay();
						this.swapOutATC();
						this.swapOutIcons();
						this.swapMetafieldContent();
						this.displayTitles.forEach((el) => { el.innerHTML = this.selectedProduct.title.split('|')[0].split(' x ')[0]; });
						[...this.querySelectorAll('[data-show]')].forEach((el) => {
							if (el.dataset.show === productId || el.dataset.show === this.baseProduct.id) {
								el.style.display = null;
								return;
							}
							el.style.display = 'none';
						});
						this.mainSelect.innerHTML = `${this.selectedProduct.variants.map((variant) => `
							<option value="${variant.id}"
								${variant.id === this.currentVariant?.id ? 'selected="selected"' : ''}
							>
								${variant.title} - ${variant.price_money}
							</option>
						`).join('')}`;
						const lateInput = this.querySelector('input[name=late]');
						this.selectedProduct.tags.includes('late-notice') ? lateInput.value = true : lateInput.value = false;
						history.replaceState(this.selectedProduct.title, '', this.selectedProduct.url);
						break;
					case 'option-choice':
						if (!option) {
							console.error('Input with [data-action="option-choice"] is missing a [data-option="value"] attr');
							return;
						}

						const optionIndex = this.selectedProduct.options_with_values
							.findIndex(({ values }) => values
								.find(x => x === option));
						let thisOptionSet = [...this.currentVariant.options];
						thisOptionSet[optionIndex] = option;

						this.currentVariant = this.selectedProduct.variants
							.find(({ options }) => options.every((x) => thisOptionSet.find((y) => y === x)));

						// this.enableOrDisableOptionSelects();
						this.populateSelectedProductPrice();
						this.swapOutATC();
						this.swapOutIcons();
						this.mainSelect.value = this.currentVariant.id;
						// history.replaceState(this.selectedProduct.title, '', this.currentVariant.url);
						window.dispatchEvent(this.variantUpdatedEvent);
						this.populateSizeDisplay();

						this.imagesWrapper.forEach(wrapper => {
							const variantImage = [...wrapper.querySelectorAll('[data-variants]')].find(({ dataset: { variants } }) => {
								return variants.includes(this.currentVariant.id);
							});
							if (variantImage) {
								wrapper.insertBefore(variantImage, wrapper.firstChild);
							}
						});
						break;
					default: break;
				}
			});
		}

		populateSizeDisplay() {
			const sizeOption = this.selectedProduct.options_with_values?.find(({ name }) => name.toLowerCase() === 'size');
			if (!sizeOption) return;

			const sizeValue = this.currentVariant.options.find((option) => sizeOption.values.includes(option));
			if (!sizeValue) return;

			[...this.querySelectorAll('[data-size-display]')].forEach((el) => {
				el.innerHTML = sizeValue;
			});
		}

		createCustomEvents() {
			this.addToCartEvent = new CustomEvent('coco-shuffle:add-to-cart', {});
			this.productUpdatedEvent = new CustomEvent('coco-shuffle:product-updated', {});
			this.variantUpdatedEvent = new CustomEvent('coco-shuffle:variant-updated', {});
		}

		enableOrDisableOptionSelects() {
			const optionSelects = [...this.querySelectorAll('[data-option]')];
			const availableOptions = this.selectedProduct.variants.map((variant) => {
				if (!variant.available) return;
				return variant.options.map((x) => x);
			}).filter(x => x);

			optionSelects.forEach((select) => {
				const optionValue = select.dataset.option;
				const optionIndex = this.selectedProduct.options_with_values
					.findIndex(({ values }) => values
						.find(x => x === optionValue));

				const available = availableOptions.find((optionSet) => {
					let thisOptionSet = [...this.currentVariant.options];
					thisOptionSet[optionIndex] = optionValue;
					return thisOptionSet.every((x) => optionSet.find((y) => y === x));
				});

				// customized for OOS messaging on Ghost
				if (available) {
					// select.removeAttribute('disabled', true);
					select.querySelector('[data-sold-out]')?.remove();
				} else {
					// select.setAttribute('disabled', true);
					if (!select.querySelector('[data-sold-out]')) select.innerHTML += '<div data-sold-out class="ml-auto mr-4">Sold Out</div>';
				}
			});

			// customized for the pdp dropdowns
			if (this.currentVariant.available) {
				[...this.querySelectorAll('[data-fake-select-value] [data-sold-out]')].forEach(el => el.remove());
			}
		}

		populateSelectedProductImages() {
			this.imagesWrapper.forEach(wrapper => {
				wrapper.style.transition = '0.2s';
				wrapper.style.opacity = 0;
				// set this min height to prevent big reflow
				wrapper.style.minHeight = `${wrapper.offsetHeight}px`;

				// all done loading! yay
				const onLoad = () => {
					wrapper.style.opacity = 1;
					wrapper.style.minHeight = 0;
					window.dispatchEvent(new CustomEvent('coco-shuffle:product-updated', { detail: this.selectedProduct.id }));
				};

				// is there a template defined?
				const template = this.querySelector('[data-template="product-image"]')?.innerText.replaceAll('`', '');
				const oddClasses = this.querySelector('[data-template="product-image"]')?.dataset?.applyWhenOdd;
				const isOdd = this.selectedProduct.images.length % 2 === 1;
				setTimeout(() => {
					const imagesHtmlString = this.selectedProduct.images.map(({ alt, src, variants }) => {
						let alt_downcase = alt ? alt.toLowerCase() : false,
							hide_alts = ['info|', 'hide_image'],
							hide_img = hide_alts.some(str => alt_downcase.includes(str));

						if (!hide_img) {
							if (!template) return `
								<img alt="${alt ? alt : this.selectedProduct.title}" src="${src}">
							`;
							return template.replace('{src}', src).replace('{alt}', alt).replace('{variants}', variants).replace('{classes}', isOdd ? oddClasses : '');
						}
					}).join('');
					wrapper.innerHTML = imagesHtmlString;

					if (this.selectedProduct.product_features?.length) {
						const featureIconsHtml = `
							<div data-feature-icons class="swiper-no-swiping absolute top-3 right-3 flex items-center gap-2 z-10 pointer-events-none">
								${this.selectedProduct.product_features.map(f =>
									`<img loading="lazy" data-feature-icon class="w-15 h-15 object-contain" src="${f.icon}" />`
								).join('')}
							</div>
						`;
						const firstSlide = wrapper.querySelector('[data-variants]');
						if (firstSlide) {
							firstSlide.style.position = 'relative';
							firstSlide.insertAdjacentHTML('beforeend', featureIconsHtml);
						}
					}

					// inject badge onto first slide
					const firstSlideForBadge = wrapper.querySelector('[data-variants]');
					if (firstSlideForBadge) {
						firstSlideForBadge.style.position = 'relative';
						firstSlideForBadge.insertAdjacentHTML('afterbegin', this.buildBadgeHTML());
					}

					// when the last image is loaded, reset some styles
					const allImages = [...wrapper.querySelectorAll('img')];
					allImages[allImages.length - 1].onload = onLoad;
				}, 200);
			});
		}

		populateSelectedProductPrice() {
			if (!this.currentVariant || !this.displayPrices?.length) return;

			let sub_price = '';
			const bmsmSelected = this.querySelector('[data-bmsm]:checked')?.dataset.bmsm;
      const currency = window.Shopify.currency.active;

			if (this.currentVariant.selling_plan_allocations.length > 0) {
				const percentTag = Number(this.querySelector('selling-plan-selector')?.dataset?.percentTag ?? 0);
				const compareAtPrice = this.currentVariant.compare_at_price || this.currentVariant.selling_plan_allocations[0].compare_at_price;
				const rawPrice = (percentTag > 0 && compareAtPrice)
					? Math.round(compareAtPrice * (1 - percentTag / 100))
					: this.currentVariant.selling_plan_allocations[0].price;
				sub_price = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: currency,
				}).format(rawPrice / 100);
			}

			const subscriptionSelected = this.querySelector('[value="subscribe"]')?.checked;
			let newPriceMarkup = `
				<span class="relative">
					<span data-price class="after:absolute after:inset-0 after:h-0.5 after:w-full after:top-1/2 after:-translate-y-1/2 after:content-['']">${this.currentVariant.price_money}</span>
				</span>
			`;
			if (subscriptionSelected && sub_price) {
				newPriceMarkup = `
					<span class="text-accent1 mr-2">${sub_price}</span>
					<span class="line-through">${this.currentVariant.price_money}</span>
				`;
			} else if (bmsmSelected) {
				const discountOff = Number(bmsmSelected);
				const multiplier = (100 - discountOff) / 100;
				const discountPrice = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: currency,
				}).format((this.currentVariant.price * multiplier) / 100.00);

				newPriceMarkup = `
					<span class="text-accent1 mr-2">${discountPrice}</span>
					<span class="line-through">${this.currentVariant.price_money}</span>
				`;
			} else if (this.currentVariant?.compare_at_price > this.currentVariant.price) {
				newPriceMarkup = `
					<span class="line-through text-accent1 mr-2">${this.currentVariant.compare_at_price_money}</span>
					<span>${this.currentVariant.price_money}</span>
				`;
			}

			this.displayPrices.forEach((el) => { el.innerHTML = newPriceMarkup; });
		}

		populateSelectedProductOptions() {
			const optionsHTMLString = this.selectedProduct.options_with_values.map(({ name, values }, i) => {
				const optionIndex = i;
				if (values.length < 2) return;
				if (name.toLowerCase().includes('flavor') || name.toLowerCase().includes('color')) {
					return `
						<div class="flex items-center justify-between pb-3 pt-7.5">
							<span class="font-heading font-black uppercase">${name} (${values.length})</span>
						</div>
						<div data-fake-select-expanding-wrapper class="transition-all duration-500">
							<fake-select data-value="${this.currentVariant.options[optionIndex]}" class="block border-b border-secondaryLight text-left relative w-full" role="combobox" aria-haspopup="listbox" aria-expanded="false" aria-controls="product-select">
								<button data-dropdown-action="toggle-dropdown" class="flex gap-4 h5 font-body items-center py-2 w-full">
									<div data-fake-select-value class="flex gap-4 items-center text-left">
										<div class="relative rounded-full bg-secondaryLight w-7.5 h-7.5">
											<div aria-hidden="true" style="background-image: url('{{ filename }}')" class="w-full h-full shadow rounded-full bg-cover bg-center"></div>
										</div>
										<span class="capitalize">${this.currentVariant.options[optionIndex]}</span>
									</div>
									${this.currentVariant.available ? '' : '<div data-sold-out class="ml-auto mr-4">Sold Out</div>'}
									<div data-rotate class="ml-auto w-3 h-3 transition-all duration-200" aria-hidden="true">
										<span class="w-full h-full transform rotate-90 block">
											<svg xmlns="http://www.w3.org/2000/svg" data-name="Group 490" width="100%" height="100%" viewBox="0 0 8 14">
												<defs>
													<clipPath id="dpuo5a2tba">
														<path data-name="Rectangle 50" d="M0 0h8v14H0z"/>
													</clipPath>
												</defs>
												<path fill="currentColor" data-name="Path 23" d="M1.351 14 0 12.658 5.693 7 0 1.342 1.351 0 7.72 6.329a.945.945 0 0 1 0 1.342z" style="clip-path:url(#dpuo5a2tba)"/>
											</svg>
										</span>
									</div>
								</button>
								<div id="product-select" role="listbox" data-dropdown style="height: 0;" class="absolute w-full top-full overflow-hidden transition-all duration-200 shadow bg-primaryLight">
									<ul class="border border-primaryDark max-h-[440px] overflow-y-scroll py-3 px-5">
										${values.map((value) => {
											const available = this.selectedProduct.variants.find(({ available, options }) => available && options.find((x) => x == value));
											return `
												<li data-fake-option class="border-b border-secondaryLight">
													<button
														${available ? '' : 'disabled'}
														data-value="${value}"
														data-dropdown-action="select"
														class="disabled:opacity-20 flex gap-4 items-center p-2 transition duration-200 focus:bg-secondaryLight hover:bg-secondaryLight h5 font-body w-full group"
														data-option="${value}"
														data-action="option-choice"
													>
														<div class="relative rounded-full bg-secondaryLight min-w-[30px] w-7.5 h-7.5">
															<div aria-hidden="true" style="background-image: url('{{ filename }}')" class="w-full h-full shadow rounded-full bg-cover bg-center"></div>
														</div>
														<div class="flex-shrink text-left">
															<span class="capitalize">${value.toLowerCase()}</span>
														</div>
														${available ? '<div data-sold-out class="ml-auto mr-4">Sold Out</div>' : ''}
														<div data-checkmark class="{% unless value == default_value %} hidden {% endunless %} w-3 h-3 ml-auto">
															<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 12 9">
																<defs>
																	<clipPath id="h9mzceli1a">
																		<path data-name="Rectangle 45" d="M0 0h12v9H0z"/>
																	</clipPath>
																</defs>
																<path color="currentColor" data-name="Path 23" d="M3.94 9a.705.705 0 0 1-.506-.215L0 5.264l1.013-1.039 2.927 3L10.987 0 12 1.039 4.446 8.785A.705.705 0 0 1 3.94 9" style="clip-path:url(#h9mzceli1a)"/>
															</svg>
														</div>
													</button>
												</li>
											`;
										}).join('')}
									</ul>
								</div>
							</fake-select>
						</div>
					`;
				} else {
					return `
						<div class="flex items-center justify-between pb-3 pt-7.5">
							<span class="font-heading font-black uppercase">${name} (${values.length})</span>
						</div>
						<fieldset>
							<legend class="sr-only">${name}</legend>
							<ul class="flex flex-wrap">
								${values.map((value) => {
									const available = this.selectedProduct.variants.find(({ available, options }) => available && options.find((x) => x == value));
									return `
										<li>
											<div class="relative">
												<input
													class="absolute top-0 left-0 h-full w-full opacity-0 peer cursor-pointer z-10"
													${this.currentVariant?.options
														?.find((x) => x === value) ? 'checked' : ''}
													data-action="option-choice"
													data-option="${value}"
													id="${name}__${value}"
													aria-label="${value}"
													type="radio"
													name="${name.toLowerCase()}-select"
													value="${value}"
												/>
												<label class="text-small after:absolute after:top-px after:z-1 after:bottom-px after:left-px after:right-px after:border after:border-transparent peer-checked:after:border-current block border border-secondaryDark ${available ? '' : `opacity-20`} peer-checked:border-current w-15 min-w-max p-4 text-center" for="${name}__${value}">
													${value}
												</label>
											</div>
										</li>
									`;
								}).join('')}
							</ul>
						</fieldset>
					`;
				}
			}).join('');

			this.displayOptions.innerHTML = optionsHTMLString;
		}

		swapMetafieldContent() {
			this.selectedProduct.metafields.forEach(x => {
				let metafield = x;
				const el = document.querySelector(`.${metafield.name}`);
				if (!el) return;
				const fallbackMetafield = this.baseProduct?.metafields?.find((y) => y.name === metafield.name);

				switch (metafield.name) {
					case 'section_recommended_products':
						if (!Object.values(metafield.value || metafield.values).filter(x => x).length) {
							if (fallbackMetafield.values.length) {
								metafield = fallbackMetafield;
							} else {
								el.classList.add('hidden');
								return;
							}
						}
						el.classList.remove('hidden');

						const swiper = el.querySelector('swiper-carousel')?.swiper;
						if (!swiper) return;

						const swiperWrapper = el.querySelector('.swiper-wrapper');
						el.querySelector('.swiper-wrapper').innerHTML = `
							${metafield.values.map((handle) => `<div class="swiper-slide"><quick-buy data-product-handle="${handle}"></quick-buy></div>`).join('')}
						`;
						const observer = new MutationObserver(() => swiper.update());

						observer.observe(swiperWrapper, {
							subtree: true,
							childList: true
						});
						break;
					case 'section_big_youtube_video':
						if (!metafield.value.youtube_url) {
							if (fallbackMetafield.value.youtube_url) {
								metafield = fallbackMetafield;
							} else {
								el.classList.add('hidden');
								return;
							}
						}
						el.classList.remove('hidden');

						const imageSrc = metafield.value.poster_image_url;
						const id = getYoutubeIdFromUrl(metafield.value.youtube_url);
						const wrapper = el.querySelector('[data-video-wrapper]');
						if (!wrapper || !id || !imageSrc) return;

						wrapper.innerHTML = `
							<div
								data-youtube-sdk-overlay="${id}"
								${imageSrc ? `style="background-image: url('${imageSrc}')" ` : ''}
								class="${imageSrc ? 'bg-center bg-cover' : 'bg-transparent'} absolute cursor-pointer hover:text-accent1 transition duration-200 flex items-center justify-center top-0 left-0 h-full w-full"
								role="button"
								aria-label="Play video"
							>
							${imageSrc ? `
								<span class="block w-16 h-16 text-primaryLight">
									<svg aria-hidden="true" focusable="false" role="presentation" width="100%" height="100%" class="icon icon-youtube" viewBox="0 0 100 70">
										<path d="M98 11c2 7.7 2 24 2 24s0 16.3-2 24a12.5 12.5 0 01-9 9c-7.7 2-39 2-39 2s-31.3 0-39-2a12.5 12.5 0 01-9-9c-2-7.7-2-24-2-24s0-16.3 2-24c1.2-4.4 4.6-7.8 9-9 7.7-2 39-2 39-2s31.3 0 39 2c4.4 1.2 7.8 4.6 9 9zM40 50l26-15-26-15v30z" fill="currentColor">
									</svg>
								</span>
								` : ''}
							</div>
							<div data-youtube-sdk-player data-video-id="${id}"></div>
						`;
						window.loadVideos();
						break;
					case 'section_product_page_slider':
						if (!metafield.value.images.length && !metafield.value.tagline && !metafield.value.title) {
							if (fallbackMetafield.value.tagline || fallbackMetafield.value.title || fallbackMetafield.value.images.length) {
								metafield = fallbackMetafield;
							} else {
								el.classList.add('hidden');
								return;
							}
						}
						el.classList.remove('hidden');

						const productSwiper = el.querySelector('swiper-carousel')?.swiper;
						if (!productSwiper) return;

						const productSwiperWrapper = el.querySelector('.swiper-wrapper');
						el.querySelector('.swiper-wrapper').innerHTML = `
							${metafield.value.images.map((src) => `
							<div class="swiper-slide object-cover object-center aspect-[3/4] bg-primaryLight md:max-w-[40vw]">
								<img loading="lazy" width="1200" height="1200" class="block w-full h-full object-cover object-center" src="${src}" srcset="${src}&width=352 352w, ${src}&width=832 832w, ${src}width=1200 1200w"/>
							</div>
							`).join('')}
						`;

						productSwiper.update();
						const productObserver = new MutationObserver(() => productSwiper.update());
						productObserver.observe(productSwiperWrapper, {
							subtree: true,
							childList: true
						});

						el.querySelector('[data-tagline').innerHTML = metafield.value.tagline;
						break;
					case 'section_accordion_image_columns':
						if (!metafield.value.accordions.length && !metafield.value.image_url && !metafield.value.title) {
							if (fallbackMetafield.value.accordions.length || fallbackMetafield.value.image_url || fallbackMetafield.value.title) {
								metafield = fallbackMetafield;
							} else {
								el.classList.add('hidden');
								return;
							}
						}
						el.classList.remove('hidden');

						const img = el.querySelector('[data-main-img] img');
						const logobar = el.querySelector('[data-logo-bar]');
						const title = el.querySelector('.h1');
						const accordion = el.querySelector('content-accordion');

						img.src = metafield.value.image_url;
						img.srcset = `${img.src}&width=352 352w, ${img.src}&width=832 832w, ${img.src}width=1200 1200w`;
						title.innerHTML = metafield.value.title;

						if (metafield.value.logo_bar_url.length) {
							logobar.innerHTML = `
								<img src="${metafield.value.logo_bar_url}" width="1200" height="246" class="w-full object-center object-fit">
							`;
						} else {
							logobar.innerHTML = '';
						}
						if (accordion && metafield.value.accordions?.length) {
							accordion.innerHTML = `${
								metafield.value.accordions.map(({ title, body }, i) => `
									<button
										data-accordion-toggle="block-${title}-${i}"
										class="flex items-center justify-between font-heading font-black uppercase first:border-none border-t border-secondaryLight text-xl py-3 w-full"
									>
										${title}
										<div aria-hidden="true" class="w-3.5 h-3.5 relative">
											<span class="absolute top-1/2 transform translate-y-1/2 left-0 w-full block border border-current"></span>
											<span class="absolute block w-full h-0.5 top-1/2 transform translate-y-1/2">
												<span data-rotate-active class="transform rotate-90 transition duration-200 left-0 w-full block border border-current"></span>
											</span>
										</div>
									</button>
									<div class="overflow-hidden transition-all duration-500" style="height: 0;" data-accordion-content="block-${title}-${i}">
										<div class="font-body font-bold leading-loose py-3">${body}</div>
									</div>
								`).join('')
							}`;
						}
						break;
					case 'section_copy':
						if (!metafield.value.title && !metafield.value.body) {
							if (fallbackMetafield.value.title && fallbackMetafield.value.body) {
								metafield = fallbackMetafield;
							} else {
								el.classList.add('hidden');
								return;
							}
						}
						if (window.matchMedia('min-width: 768px')) {
							this.stickyCopy.classList.add('hidden');
							this.copySection.classList.remove('hidden');
						} else {
							this.copySection.classList.add('hidden');
							this.stickyCopy.classList.remove('hidden');
						}

						[this.copySection, this.stickyCopy].forEach(el => {
							const heading = el.querySelector('.container > strong');
							const body = el.querySelector('.container > div');

							heading.innerHTML = metafield.value.title;
							body.innerHTML = metafield.value.body;
						});
						break;
					default: break;
				}
			});
		}

		buildBadgeHTML() {
		const tags = this.selectedProduct.tags;
		const available = this.selectedProduct.available;

		const appExclusive = tags.includes('app_exclusive');
		const goldExclusive = tags.includes('loyalty_tier_gold_exclusive');
		const silverExclusive = tags.includes('loyalty_tier_silver_exclusive');
		const bronzeExclusive = tags.includes('loyalty_tier_bronze_exclusive');

		let innerHtml = '';

		if (!available) {
			innerHtml += `<div data-out-of-stock class="px-2.5 py-1.5 bg-primaryDark text-primaryLight">Out of stock</div>`;
		}

		tags.forEach(tag => {
			const lightMatch = tag.match(/^badge-light[_:](.+)$/);
			const darkMatch = tag.match(/^badge[_:](.+)$/);
			if (lightMatch) {
				innerHtml += `<div class="px-2.5 py-1.5 bg-primaryLight">${lightMatch[1]}</div>`;
			} else if (darkMatch) {
				innerHtml += `<div class="px-2.5 py-1.5 bg-primaryDark text-primaryLight">${darkMatch[1]}</div>`;
			}
		});

		if (appExclusive) {
			innerHtml += `<div class="px-2.5 py-1.5 bg-primaryDark text-primaryLight">App Exclusive</div>`;
		}

		if (goldExclusive && !silverExclusive && !bronzeExclusive) {
			innerHtml += `<div class="px-2.5 py-1.5 bg-primaryDark text-primaryLight">Gold Exclusive</div>`;
		} else if (silverExclusive || bronzeExclusive) {
			innerHtml += `<div class="px-2.5 py-1.5 bg-primaryDark text-primaryLight">Loyalty Member Exclusive</div>`;
		}

		return `<div data-badge-wrap class="absolute top-5 text-tiny italic uppercase left-0 h-max max-w-[70%] flex flex-wrap items-center gap-1.5 z-20">${innerHtml}</div>`;
	}

	swapOutATC() {
			const hideBis = !!this.selectedProduct.tags.find(x => x === 'hide_bis') || !this.querySelector('[data-notify-me]');
			if (hideBis) {
				this.querySelector('[data-out-of-stock]')?.classList.add('peer-disabled:block');
				this.querySelector('[data-notify-me]')?.classList.remove('peer-disabled:block');
			} else {
				this.querySelector('[data-out-of-stock]')?.classList.remove('peer-disabled:block');
				this.querySelector('[data-notify-me]')?.classList.add('peer-disabled:block');
			}

			if (!this.querySelector('[data-action="add-to-cart"]')) return;
			if (!this.currentVariant?.available) {
				this.querySelector('[data-action="add-to-cart"]').setAttribute('disabled', true);
				return;
			} else {
				this.querySelector('[data-action="add-to-cart"]').removeAttribute('disabled', true);
			}
		}

		swapOutIcons() {
			const showVegan = !!this.selectedProduct.tags.find(x => x === 'vegan-friendly');

			if (showVegan) {
				[...this.querySelectorAll('[data-vegan-icon]')].forEach(icon => {
					icon.classList.remove("hidden");
				});
			} else {
				[...this.querySelectorAll('[data-vegan-icon]')].forEach(icon => {
					icon.classList.add("hidden");
				});
			}
			const showSoy = !!this.selectedProduct.tags.find(x => x === 'soy-free');

			if (showSoy) {
				[...this.querySelectorAll('[data-soy-icon]')].forEach(icon => {
					icon.classList.remove("hidden");
				});
			} else {
				[...this.querySelectorAll('[data-soy-icon]')].forEach(icon => {
					icon.classList.add("hidden");
				});
			}
			const showSugar = !!this.selectedProduct.tags.find(x => x === 'sugar-free');

			if (showSugar) {
				[...this.querySelectorAll('[data-sugar-icon]')].forEach(icon => {
					icon.classList.remove("hidden");
				});
			} else {
				[...this.querySelectorAll('[data-sugar-icon]')].forEach(icon => {
					icon.classList.add("hidden");
				});
			}
			const showGluten = !!this.selectedProduct.tags.find(x => x === 'gluten-free');

			if (showGluten) {
				[...this.querySelectorAll('[data-gluten-icon]')].forEach(icon => {
					icon.classList.remove("hidden");
				});
			} else {
				[...this.querySelectorAll('[data-gluten-icon]')].forEach(icon => {
					icon.classList.add("hidden");
				});
			}
		}

		ageCheck() {
			const visitorLocation = JSON.parse(sessionStorage.getItem('visitor_location'));
			const ageCheck = this.querySelector('[data-age-check]');
			if (ageCheck != null && visitorLocation.state_prov == 'New York') {
				ageCheck.classList.remove('hidden');
				ageCheck.querySelector('input').setAttribute('required', 'required');
			}
		}
	}

	customElements.define('coco-shuffle', CocoShuffle);
}